import { render } from "./ErrorAlert.vue?vue&type=template&id=2d523c95&ts=true"
import script from "./ErrorAlert.vue?vue&type=script&lang=ts"
export * from "./ErrorAlert.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__